import React, { useEffect, useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AUTHENTICATED_ENTRY,
  AUTHENTICATED_ENTRY_ADMIN,
  AUTHENTICATED_PURCHASING_WORKSPACE_ENTRY,
  AUTHENTICATED_WORKSPACE_ENTRY,
} from "configs/AppConfig";

import { SYSTEM_ROLES, WORKSPACE } from "constants/AuthConstant";
import { getMyPermission } from "store/slices/workspaceSlice";
import { WORKSPACES } from "constanst";
import navigationConfig from "configs/NavigationConfig";
import { profileSelector } from "store/selector/AuthSelector";
import { findMenuPath, getFirstChildPath, getSideNavMenuItem } from "utils/helper";

const PublicRoute = () => {
  const dispatch = useDispatch();
  
  const { token, userRoles } = useSelector((state) => state.auth);
  const { permissions, loading } = useSelector((state) => state.permissionApi);
  const profile = useSelector(profileSelector);
  const currentWorkspace = localStorage.getItem(WORKSPACE);
  const isWorkspaceCompany = localStorage?.getItem(WORKSPACE) === WORKSPACES.COMPANY;
  const isWorkspacePurchasing = localStorage?.getItem(WORKSPACE) === WORKSPACES.PURCHASING;
  const permissionCodes = permissions?.permissionCodes;

  useEffect(() => {
    if (token) dispatch(getMyPermission());
  }, [token]);

  const menuItems = useMemo(
    () =>
      getSideNavMenuItem(
        navigationConfig,
        userRoles,
        profile,
        permissionCodes,
        currentWorkspace,
      ),
    [userRoles, profile, permissionCodes, currentWorkspace],
  );

  if (token && (loading || !Array.isArray(permissionCodes))) {
    return null;
  }

  let defaultPath = "";

  if (userRoles.includes(SYSTEM_ROLES.OperatorAdmin))	defaultPath = AUTHENTICATED_ENTRY_ADMIN;
  else if (isWorkspaceCompany)							defaultPath = AUTHENTICATED_WORKSPACE_ENTRY;
  else if (isWorkspacePurchasing)						defaultPath = AUTHENTICATED_PURCHASING_WORKSPACE_ENTRY;
  else													defaultPath = AUTHENTICATED_ENTRY;

  const hasDefaultPath = findMenuPath(menuItems, defaultPath);
  const firstAllowedPath = getFirstChildPath(menuItems);
  const toPath = hasDefaultPath || firstAllowedPath || defaultPath;

  return token ? (
    <Navigate className="ant-menu-item-selected" to={toPath} />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;